const printAuthor = (authorCount) => {
    let content = '';

    if (authorCount > 0) {
        content = `외 ${authorCount}명`;
    }

    return content;
};

export default printAuthor;
